import React from "react";
import { leaders, advisoryBoard, executiveBoard, consultantsBoard } from "../../data/teamData";
import "./TeamStyle.css";
import { FaLinkedin } from "react-icons/fa";

function Team() {
  return (
    <div className="">
      {/* Leaders Section */}
      <section className=" w3-padding-32"> 

        <h2>Board</h2>
         <p className="">
The Board assumes ultimate responsibility for investment policy, roadmap, allocation and performance for the assets, funds and overall portfolio.Executive  Management executes investment strategies and regularly monitor portfolio performance. 
    </p>
        <div className="team-grid">
          {leaders.map((member) => (
            <div key={member.id} className="team-card">
              <img src={member.image} alt={member.name} className="team-image" />
              <h3>{member.name}</h3>
              <p>{member.role}</p>
              
              <span className="w3-text-gray">{member.description}</span>

            </div>
          ))}
        </div>
      </section>

      {/* Advisory Section */}
      <section className="team-section w3-padding-32">
      <p> </p>
        <h2>Advisory Panel</h2>

<p className="">
   Our Advisory Panel shapes our perspectives on geopolitical, economic, and market trends, bringing expertise on investment matters like global trends, emerging assets, and growth opportunities. With their extensive experience and past roles on various Board Committees, these experts guide us towards informed decisions and new prospects.
     </p>
        <div className="team-grid">
          {advisoryBoard.map((member) => (
            <div key={member.id} className="team-card">
              <img src={member.image} alt={member.name} className="team-image" />
              <h3>{member.name}</h3>
              <p>{member.role}</p>
              <span className="w3-text-gray">{member.description}</span>

            </div>
          ))}
        </div>
      </section>

      <section className="team-section  w3-padding-32">
      <p> </p>
        <h2>Executive Panel</h2>
        <p className="">
        Our Executive Panel panel evaluates, formulates, and executes investment strategies, portfolio assessments, and business development initiatives, driving excellence and value creation for our stakeholders.
       

     </p>

      <div className="team-grid">
          {executiveBoard.map((member) => (
            <div key={member.id} className="team-card">
              <img src={member.image} alt={member.name} className="team-image" />
              <h3>{member.name}</h3>
              <p>{member.role}</p>
              <span className="w3-text-gray">{member.description}</span>

            </div>
          ))}
        </div>
      </section>

       <section className="team-section  w3-padding-32">
      <p> </p>
        <h2>Legal Compliances  Panel</h2>
 <p className="">
       Our Legal Compliances Panel comprises seasoned legal experts, law firms, and partners who ensure that group maintains the highest standards of legal compliance and professionalism. The panel provides guidance on regulatory matters, risk management, and best practices, enabling us to operate with integrity and transparency.

     </p>

        <div className="team-grid">
          {executiveBoard.map((member) => (
            <div key={member.id} className="team-card">
              <img src={member.image} alt={member.name} className="team-image" />
              <h3>{member.name}</h3>
              <p>{member.role}</p>
              <span className="w3-text-gray">{member.description}</span>

            </div>
          ))}
        </div>
      </section>

         <section className="team-section  w3-padding-32">
      <p> </p>
        <h2>Risk & Controls Panel</h2>

        <p className="">
The Panel embers assesses the adequacy and effectiveness of the system of internal controls, including financial, operational and compliance controls, and risk management policies and procedures. It also supervises and evaluates the effectiveness of the internal audit function. The Panel also reviews the integrity of the financial reporting process and other related disclosures, violations, impact of financial losses, risk and risk management.

     </p>
        <div className="team-grid">
          {executiveBoard.map((member) => (
            <div key={member.id} className="team-card">
              <img src={member.image} alt={member.name} className="team-image" />
              <h3>{member.name}</h3>
              <p>{member.role}</p>
              <span className="w3-text-gray">{member.description}</span>

            </div>
          ))}
        </div>
      </section>

      <section className="team-section  w3-padding-32">
      <p> </p>
        <h2> Consultants Partners</h2>
        <p className="">
       Our Consultants and Partners Panel consists of industry experts, technology leaders, and strategic partners who collaborate  to drive innovation and excellence. The panel provides valuable insights, shares best practices, and helps us deliver cutting-edge solutions to our clients, fostering growth and success.
     </p>
        <div className="team-grid">
          {consultantsBoard.map((member) => (
            <div key={member.id} className="team-card">
              <img src={member.image} alt={member.name} className="team-image" />
              <h3>{member.name}</h3>
              <p>{member.role}</p>
              <span className="w3-text-gray">{member.description}</span>

            </div>
          ))}
        </div>
      </section>



    </div>
  );
}

export default Team;
